<template>
  <section
    class="section section-primary is-fullheight animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->

      <div class="columns is-centered has-text-centered" v-if="requestloading">
        <loading
          line-fg-color="#2d3f51"
          size="massive"
          class="margin-100"
          spacing="55"
          text-fg-color="#fff"
          message="الرجاء الإنتظار"
        />
      </div>

      <div
        class="columns is-vcentered"
        v-else-if="!subscription && !requestsuccess && !requestloading"
      >
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <a class="has-text-black pb-20">
              <nav style="background-color: rgb(0, 0, 0); margin-bottom: -13px">
                <img
                  class
                  src="../assets/images/OlympicParis.jpg"
                  width="640"
                /></nav
            ></a>

            <div class="content has-text-right pt-30" dir="rtl">
              <p>
                <strong>
                  اكتشف العالم مع "VISA" واربح رحلة إلى الألعاب الأولمبية باريس
                  2024
                </strong>
              </p>
              <p>الشروط و الأحكام :</p>
              <ul>
                <li aria-level="1">هذا العرض خاص بالمواطنين الليبيين فقط.</li>

                <li aria-level="1">
                  يشمل العرض حاملي بطاقات :
                  <p>(VISA Gold, VISA Platinum)</p>
                </li>
                <li aria-level="1">
                  يجب أن تكون حامل لبطاقة Visa من مصرف الصحارى.
                </li>
                <li aria-level="1">
                  يجب شراء المنتجات عبر الإنترنت خلال فترة الحملة.
                </li>
                <li aria-level="1">
                  يجب تجنب القيام بالمعاملات المالية في مواقع مشبوهة وممنوعة.
                </li>
                <li aria-level="1">
                  يجب أن لا يكون للفائز سجل جنائي يؤثر على قدرته على السفر.
                </li>
                <li aria-level="1">هذا العرض ساري فقط أثناء فترة الحملة .</li>
              </ul>
              <p>تتضمن الجائزة الآتي<strong>:</strong></p>
              <ul>
                <li aria-level="1">تذاكر سفر ذهابًا وإيابًا لشخصين.</li>
                <li aria-level="1">
                  إقامة لمدة 3 ليا ٍل في فندق مايسون دي لانو، فندق فاخر ذو خمس
                  نجوم.
                </li>
                <li aria-level="1">تذاكر فئة. A لـ 3 فعاليات محددة مسبقا</li>
                <li aria-level="1">
                  خدمة سيارة خاصة للتنقل من المطار/محطة القطار في باريس.
                </li>
                <li aria-level="1">نقل من ليبيا إلى باريس.</li>
                <li aria-level="1">وجبات يومية تشمل جميع الوجبات الأساسية.</li>
                <li aria-level="1">
                  خدمة نقل مريحة ذهابًا وإيابًا إلى/من الفعاليات المجدولة عبر
                  حافلة سياحية.
                </li>
                <li aria-level="1">هدايا ومرافق بقيمة 800 دولار .</li>
                <li aria-level="1">نشاط جماعي ممتع يشمل جميع المشاركين</li>
                <li aria-level="1">الدعم الطبي والأمني لضمان راحتك وسلامتك.</li>
              </ul>
              <p>لا تشمل الباقة الآتي:</p>
              <ul>
                <li aria-level="1">
                  أي وجبة أو حدث أو نشاط خارج البرنامج المخطط الذي ستوفره Visa
                  للفائزين.
                </li>
                <li aria-level="1">
                  أي فواتير أو حوادث تحدث في الفندق (فاتورة الهاتف، استهلاك
                  المنتجات بثلاجة الغرفة، خدمة غسيل الملابس، إلخ).
                </li>
              </ul>
              <p>
                <strong>
                  استكشف العالم بثقة ورافقنا في رحلة استثنائية إلى الألعاب
                  الأولمبية باريس 2024 باستخدام بطاقتك Visa الخاصة بك!
                </strong>
              </p>
              <div
                class="hero-foot has-text-centered mt-40 mb-40 animated preFadeInUp fadeInUp"
              >
                <a
                  class="button secondary-btn btn-align modal-dismiss is-bold is-medium"
                  @click="subscribe()"
                >
                  <b>أوفق علي الشروط و الاحكام و أريد تسجيل في العرض</b>
                </a>
              </div>
            </div>
          </div>
          <div class="hero-foot has-text-centered mt-40 mt-40">
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div
        class="columns is-vcentered"
        v-else-if="!subscription && requestsuccess && !requestloading"
      >
        <div class="column is-6 is-offset-3 mt-80 mb-90">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded primary mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">check</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />
              <h1 class="title is-4 pb-10">تم ارسال طلب الاشتراك بنجاح</h1>

              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered" v-else>
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div class="flex-card raised padding-20">
            <div class="square-icon-box rounded danger mt-20">
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">close</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInLeft fadeInLeft pb-90">
              <hr />
              <h1 class="title is-4 pb-10">تم فشل ارسال طلب الاشتراك</h1>

              <h1 class="subtitle is-5">{{ errormessage }}</h1>

              <!-- 
              <h1 class="subtitle is-5">رجاء المحاولة لاحقاً</h1>-->
              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      requestloading: true,
      requestsuccess: false,
      subscription: null,
      errormessage: "",
      balance: null,
      requestInfo: {
        //Token: null,
        // Id: null,
        // AccountNo: null,
      },
    };
  },
  methods: {
    subscribe() {
      axios
        .post("/customer/subscription/subscribe", this.requestInfo)
        .then((response) => {
          this.$root.kick(response.data.message);
          this.requestloading = false;
          this.requestsuccess = true;
          this.subscription = false;
        })
        .catch((error) => {
          console.log(error.response.data);
          this.requestloading = !this.requestloading;
          this.subscription = false;
          this.requestsuccess = false;
        });
    },
  },
  mounted() {
    var user = JSON.parse(localStorage.getItem("user"));

    //let token = localStorage.getItem("token");
    //this.requestInfo.Token = token;

    this.requestInfo.customer_id = user[1];

    this.requestInfo.subscription_name = "olympic_paris";

    axios
      .post("/customer/subscription/find", this.requestInfo)
      .then((response) => {
        this.$root.kick(response.data.message);

        this.errormessage = response.data.message;

        this.requestloading = !this.requestloading;
        this.subscription = true;

        this.requestsuccess = false;
      })
      .catch((error) => {
        console.log(error.response.data);
        this.requestloading = !this.requestloading;
        this.subscription = false;
      });

    // axios
    //   .get("customer/basicData/" + this.requestInfo.Id)
    //   .then((response) => {
    //     this.$root.kick(response.data.message);

    //     console.log(response.data);

    //     this.requestInfo.AccountNo = response.data.result.MainAccountNo;

    //   })
    //   .catch((error) => {});

    // console.log(this.requestInfo);
  },
};
</script>
